import { useCallback } from "react";
import useSWR from "swr";
import { Paginated } from "../types";
import { useApi } from "./api";
import { CustomError } from "./errors";
import { Notification } from "./types/notifications";

// the key the calls that answer a request or an invite revalidate
export const NOTIFICATIONS_URL = "/notifications";

// also re-fetched on window focus (SWR default): what came meanwhile shows up without a reload
const REFRESH_INTERVAL_MS = 60_000;

export const useNotificationsApi = () => {
  const api = useApi();

  const useNotifications = useCallback(
    (enabled: boolean) =>
      useSWR<Paginated<Notification>, CustomError, string | null>(
        enabled ? NOTIFICATIONS_URL : null,
        (url) => api.get<Paginated<Notification>>({ url }),
        { refreshInterval: REFRESH_INTERVAL_MS },
      ),
    [api],
  );

  return {
    useNotifications,
  };
};
